var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "name=cloud"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.85 13.6H13.6C14.35 13.6 14.989 13.339 15.517 12.817C16.045 12.295 16.306 11.656 16.3 10.9C16.3 10.15 16.039 9.514 15.517 8.992C14.995 8.47 14.356 8.206 13.6 8.2C13.48 7.33 13.084 6.589 12.412 5.977C11.734 5.359 10.975 5.05 10.135 5.05C9.373 5.05 8.68 5.245 8.056 5.635C7.432 6.025 6.97 6.58 6.67 7.3C5.818 7.378 5.11 7.705 4.546 8.281C3.982 8.857 3.7 9.58 3.7 10.45C3.7 11.32 4.009 12.07 4.627 12.7C5.239 13.3 5.98 13.6 6.85 13.6ZM10 19C8.758 19 7.588 18.763 6.49 18.289C5.398 17.821 4.447 17.182 3.637 16.372C2.827 15.562 2.185 14.608 1.711 13.51C1.237 12.418 1 11.248 1 10C1 8.752 1.237 7.582 1.711 6.49C2.185 5.398 2.827 4.447 3.637 3.637C4.447 2.827 5.398 2.185 6.49 1.711C7.588 1.237 8.758 1 10 1C11.242 1 12.412 1.237 13.51 1.711C14.608 2.185 15.562 2.827 16.372 3.637C17.182 4.447 17.821 5.398 18.289 6.49C18.763 7.588 19 8.758 19 10C19 11.242 18.763 12.412 18.289 13.51C17.821 14.608 17.182 15.562 16.372 16.372C15.562 17.182 14.608 17.821 13.51 18.289C12.418 18.763 11.248 19 10 19Z",
    fill: "#CCCFD1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCloud);
export default __webpack_public_path__ + "static/media/icon-cloud.007a56ec22e5ebd516772259dd4f64d9.svg";
export { ForwardRef as ReactComponent };